/* eslint-disable import/order */
import { BrowserRouter } from "react-router-dom"
import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"

import store from "./store"

import "sanitize.css/sanitize.css"
import "./styles/index.scss"

import Head from "./components/Head"
import App from "./components/App"

const target = document.getElementById("root")

const root = ReactDOM.createRoot(target)
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Head />
      <App />
    </BrowserRouter>
  </Provider>
)
